import Vue, { VNode } from 'vue';
import { VIcon } from 'vuetify/lib';

export default Vue.extend({
  name: 'LocationPinIcon',
  functional: true,
  render(createElement, context): VNode {
    return createElement(VIcon, context.data, 'mdi-map-marker');
  },
});
